import { Formik } from "formik";
import { InstructionsPage } from "../../../Registration/InstructionsPage/InstructionsPage";
import Input from "../../../shared/Input/Input";
import Button from "@mui/material/Button";
import { useLazyValidateBpSiteIdQuery } from "../../../../services/rtkQueryServices/authenticationService";
import { useState } from "react";
import { LOGIN_LITERALS } from "../../../../constants/literals";
import ConfirmationDialog from "../../../shared/ConfirmationDialog/ConfirmationDialog";
import { ReactComponent as InfoIcon } from "../../../../assets/svg/info_lg.svg";
export const BpSiteIdVerificationHandler = (props: any) => {
  const [validateBpSiteId] = useLazyValidateBpSiteIdQuery();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showErrorDialog, setShowErrorDialog] = useState<boolean>(false);

  return (
    <>
      <ConfirmationDialog
        open={showErrorDialog}
        contentBody={
          <div className="d-flex flex-column justify-content-center  align-items-center gap-8">
            <InfoIcon />
            <div className="bp-validation-error">
              We cannot connect to your BP System.
            </div>
            <p className="pt-2">
              Please Contact our support team at support@incahealth.com.au
            </p>
          </div>
        }
        onOk={() => {
          setShowErrorDialog(false);
        }}
        onClose={() => {
          setShowErrorDialog(false);
        }}
        okButtonName="Ok"
        okButtonClassName="button-danger dialog-btn"
      />
      <div className="pt-4">
        <Formik
          initialValues={{ bpSiteId: "" }}
          onSubmit={(values) => {
            validateBpSiteId({
              bpSiteId: values.bpSiteId,
            }).then((res) => {
              if (res.isSuccess && res.data.data) {
                props.onClose();
              } else if (res.isSuccess && !res.data.data) {
                setShowErrorDialog(true);
              } else if (res.isError) {
                setErrorMessage(
                  (res.error as any)?.data?.message ||
                    LOGIN_LITERALS.somethingWentWrong
                );
              }
            });
          }}
        >
          {(formik) => (
            <form
              //   onKeyDown={Utility.preventSubmitOnEnter}
              onSubmit={formik.handleSubmit}
              className="d-flex flex-column registration-form instructions-container align-items-center"
            >
              <InstructionsPage />
              <div className="pt-3 bp-site-input">
                <Input
                  name="bpSiteId"
                  placeholder="BP Site ID"
                  onChange={formik.handleChange}
                  onInput={() => {
                    setErrorMessage("");
                  }}
                  value={formik.values.bpSiteId}
                  errorMsg={
                    (formik.touched.bpSiteId || formik.submitCount > 0) &&
                    formik.errors.bpSiteId &&
                    (formik.errors as any).bpSiteId
                  }
                  maxLength={64}
                  label="BP Site ID"
                />
              </div>
              {errorMessage && (
                <div className="error-message align-self-center">
                  {errorMessage}
                </div>
              )}

              <div className="d-flex justify-content-end flex-column gap-3 line-top py-3 registration-form-button register-submission">
                <Button
                  variant="contained"
                  type="submit"
                  disabled={!formik.isValid || !formik.dirty}
                >
                  Submit
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </>
  );
};
